module.exports = __webpack_public_path__ + "img/banner_2.6a7819f3.png";